import { createKeySelector, createDynamicKeySelector } from 'state/common/selectorFactories';

import { EMPTY_OBJECT } from 'config/constants';

import type { Extra } from 'types/shows';

export const getExtrasData = (state: any) => state.extras || EMPTY_OBJECT;
export const getExtrasMap = createKeySelector(getExtrasData, 'byId', EMPTY_OBJECT);
export const getExtraById = createDynamicKeySelector<Extra | undefined | null, string>(getExtrasMap, null);
